import {
  Box,
  ToggleButtonGroup as MuiToggleButtonGroup,
  styled,
  ToggleButton,
} from '@mui/material';

type Props<T> = {
  title?: string;
  options: T[];
  value: T;
  onChange: (val: T) => void;
};

const Root = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
});

const ToggleButtonGroup = styled(MuiToggleButtonGroup)(
  ({ theme: { palette, utils, spacing, breakpoints } }) => ({
    display: 'flex',
    alignItems: 'flex-start',
    gap: spacing(2),

    '& .MuiToggleButtonGroup-grouped': {
      textTransform: 'capitalize',
      fontWeight: 500,
      fontSize: utils.clamp(12, 16),
      color: palette.grey[200],
      backgroundColor: palette.mapBlue[700],
      paddingLeft: spacing(2),
      paddingRight: spacing(2),
      margin: 0,
      borderRadius: 10,
      border: '1px solid transparent',
      opacity: 0.5,
      transition: 'all 0.2s ease-in-out',

      [breakpoints.down('xl')]: {
        padding: spacing(0.5, 1),
      },

      '&:hover': {
        opacity: 0.9,
        backgroundColor: palette.mapBlue[500],
        cursor: 'pointer',
      },

      '&.Mui-selected': {
        opacity: 1,
        backgroundColor: palette.mapBlue[600],
        color: palette.common.white,
      },
    },
  }),
);

export const ToggleGroupSection = <T extends string>({
  options,
  value,
  onChange,
}: Props<T>) => (
  <Root display="flex" justifyContent="center" gap={1} my={1}>
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={(_, val) => val && onChange(val)}
      size="small"
    >
      {options.map(opt => (
        <ToggleButton key={opt} value={opt}>
          {opt}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  </Root>
);
